/* eslint-disable multiline-ternary */
import React from 'react'
import PropTypes from 'prop-types'
import resolveProps from '../../utils/resolveProps'


const config = {
  types: [
    {
      title: 'lg',
      isDefault: true
    },
    'sm'
  ],
  modifiers: [
    'heightAuto'
  ]
}
export default function Modal(props) {
  let { data, isOpen, sm, heightAuto, onCloseClick, ...rest } = props
  data = data || {}
  onCloseClick = onCloseClick || data.onCloseClick
  isOpen = isOpen || data.isOpen

  return (
    <div
      {...rest}
      aria-hidden={isOpen ? 'false' : 'true'}
      className={
        resolveProps(props, config, 'Modal') + (isOpen ? ' mdn-isOpen' : '')
      }
    >
      <div className="mdn-Modal-content">
        <div className="mdn-Modal-header">
          {data.header}
          <button
            {...data.buttonProps}
            onClick={onCloseClick}
            aria-label="Button close modal"
            role="button"
            className="mdn-Button-header-close mdn-Button mdn-Button--icon mdn-Button--secondary"
          >
            <span className="mdn-Icon-fechar mdn-Icon--md" aria-label="Fechar modal" ></span>
          </button>
        </div>
        <div className="mdn-Divider mdn-Divider--primary"></div>
        <div className="mdn-Modal-body">{data.content}</div>
        {data.footer ? (
          <div className="mdn-Modal-footer">
            <div className="mdn-Modal-footer-start">{data.footer.content}</div>
            <div className="mdn-Modal-footer-end">{data.footer.action}</div>
          </div>
        ) : (
          ''
        )}
      </div>
    </div>
  )
}

Modal.propTypes = {
  data: PropTypes.shape({
    header: PropTypes.node,
    buttonProps: PropTypes.object,
    content: PropTypes.node,
    footer: PropTypes.object,
    isOpen: PropTypes.bool,
    sm: PropTypes.bool,
    md: PropTypes.bool,
    lg: PropTypes.bool,
    heightAuto: PropTypes.bool,
    onCloseClick: PropTypes.func
  })
}
